import { Routes } from '@/routes';

export default {
	'download.list': () => import('@/modules/download/index'),
} as Routes;
